import React, { useState, useEffect } from 'react';

function DigitalMarketingAuditSection() {
  const words = ['Social media', 'SEO', 'Website', 'Digital'];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const fullWord = words[currentWordIndex];
    let timer;

    if (!isDeleting) {
      if (currentText.length < fullWord.length) {
        timer = setTimeout(() => {
          setCurrentText(fullWord.slice(0, currentText.length + 1));
        }, 120);
      } else {
        timer = setTimeout(() => {
          setIsDeleting(true);
        }, 1800);
      }
    } else {
      if (currentText.length > 0) {
        timer = setTimeout(() => {
          setCurrentText(fullWord.slice(0, currentText.length - 1));
        }, 70);
      } else {
        setIsDeleting(false);
        setCurrentWordIndex((prev) => (prev + 1) % words.length);
      }
    }

    return () => clearTimeout(timer);
  }, [currentText, isDeleting, currentWordIndex]);

  return (
    <section className="dig-audit-section">
      <div className="dig-audit-bg-glow"></div>
      <div className="container dig-audit-container">
        {/* Left Column: Heading & Content */}
        <div className="dig-audit-left">
          <h2 className="dig-audit-title">
            Get Growth Roadmap with a Free <br />
            <span className="typewriter-highlight text-red">
              {currentText}
              <span className="typewriter-cursor">|</span>
            </span>{' '}
            Audit!
          </h2>

          <p className="dig-audit-desc">
            We rethink business growth for you through our collective experience with strategic partner ecosystem. Let's discuss your next move.
          </p>

          <p className="dig-audit-desc">
            Our services maintain transparency with clients throughout the entire process. We're your reliable and trustworthy partner for every digital service you need.
          </p>
        </div>

        {/* Right Column: Phone Mockup Showcase */}
        <div className="dig-audit-right">
          <div className="dig-audit-img-wrapper">
            <img 
              src="/assets/images/digital-marketing/dig-img3.webp" 
              alt="Get Growth Roadmap with a Free Digital Audit" 
              className="dig-audit-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default DigitalMarketingAuditSection;
